import { createSlice } from "@reduxjs/toolkit";
import {
  getConfigureColorsAction,
  addConfigureColorsAction,
  editConfigureColorsAction,
  resetConfigureColorsAction,
} from "../Action/configureColorAction";

const initialState = {
  colors: [],
  isLoading: false,
  isSaving: false,
  isResetting: false,
  error: null,
};

const configureColorSlice = createSlice({
  name: "configureColor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getConfigureColorsAction.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getConfigureColorsAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.colors = action?.payload?.data || action?.payload || [];
      })
      .addCase(getConfigureColorsAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(addConfigureColorsAction.pending, (state) => {
        state.isSaving = true;
        state.error = null;
      })
      .addCase(addConfigureColorsAction.fulfilled, (state, action) => {
        state.isSaving = false;
        if (action?.payload?.data && Array.isArray(action.payload.data)) {
          state.colors = action.payload.data;
        }
      })
      .addCase(addConfigureColorsAction.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.payload;
      })
      .addCase(editConfigureColorsAction.pending, (state) => {
        state.isSaving = true;
        state.error = null;
      })
      .addCase(editConfigureColorsAction.fulfilled, (state, action) => {
        state.isSaving = false;
        const payloadData = action?.payload?.data || action?.payload;
        if (Array.isArray(payloadData)) {
          if (payloadData.length > 1) {
            state.colors = payloadData;
          } else if (payloadData.length === 1 && state.colors.length > 0) {
            const updated = payloadData[0];
            const idx = state.colors.findIndex(
              (c) =>
                (updated.id && (c._id === updated.id || c.id === updated.id)) ||
                (updated._id && (c._id === updated._id || c.id === updated._id)) ||
                (updated.year && c.year === updated.year)
            );
            if (idx !== -1) {
              state.colors[idx] = { ...state.colors[idx], ...updated };
            }
          }
        }
      })
      .addCase(editConfigureColorsAction.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.payload;
      })
      .addCase(resetConfigureColorsAction.pending, (state) => {
        state.isResetting = true;
        state.error = null;
      })
      .addCase(resetConfigureColorsAction.fulfilled, (state, action) => {
        state.isResetting = false;
        if (action?.payload?.data && Array.isArray(action.payload.data)) {
          state.colors = action.payload.data;
        }
      })
      .addCase(resetConfigureColorsAction.rejected, (state, action) => {
        state.isResetting = false;
        state.error = action.payload;
      });
  },
});

export default configureColorSlice.reducer;
